import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmService } from './confirm.service';

@Injectable({
  providedIn: 'root',
})
export class HostModeService {
  public basic: SiteMode = 'BASIC';
  public advanced: SiteMode = 'ADVANCED';
  public expert: SiteMode = 'EXPERT';

  public modes: Array<{ label: string; value: string }> = [
    { label: 'Expert', value: this.expert },
    { label: 'Advanced', value: this.advanced },
    { label: 'Basic', value: this.basic },
  ];

  constructor(
    private translate: TranslateService,
    private confirmService: ConfirmService,
  ) {}

  promptSubscribeToMode(msg: string) {
    this.confirmService.confirm(
      {
        title: `<h4>${this.translate.instant(msg)}</h4>`,
        cancelButtonText: this.translate.instant('NotNow'),
        confirmButtonText: this.translate.instant('ContactUs'),
      },
      () => window['groove'].widget.open(),
    );
  }

  isAdvanced(mode: SiteMode) {
    return mode == this.advanced || mode == this.expert;
  }

  isExpert(mode: SiteMode) {
    return mode == this.expert;
  }
}

export type SiteMode = 'BASIC' | 'EXPERT' | 'ADVANCED';
